import { useEffect, useState } from 'react';
import { buildPlans, DEFAULT_PLANS, PLAN_LABELS } from './plans';

const API_URL = process.env.REACT_APP_API_URL || 'http://api.telecalx.com:8000';

// One request per page load, shared by every component that shows plans; its result is kept for the components
// that mount later, so they start with the admin's names straight away.
let request = null;
let loaded = null; // {plans, names}
const fetchPlans = () => {
  request ||= fetch(`${API_URL}/api/public/plans`)
    .then((r) => (r.ok ? r.json() : null))
    .catch(() => null)
    .then((d) => {
      if (!d?.plans) { request = null; return { plans: DEFAULT_PLANS, names: PLAN_LABELS }; } // try again next time
      loaded = { plans: buildPlans(d.plans, API_URL), names: { ...PLAN_LABELS, ...(d.names || {}) } };
      return loaded;
    });
  return request;
};

/**
 * The plans customers can choose, as the Super Admin set them (catalog: names, prices, cycles, buttons, features).
 * Starts with the built-in copy, so nothing waits on the network, and stays on it if the API can't be reached.
 * `loaded` is false until the request has finished (successfully or not); `names` covers every plan, hidden ones too.
 */
export default function usePlans() {
  const [state, setState] = useState(() => (loaded ? { ...loaded, loaded: true } : { plans: DEFAULT_PLANS, names: PLAN_LABELS, loaded: false }));
  useEffect(() => {
    if (loaded) return undefined;
    let alive = true;
    fetchPlans().then((d) => { if (alive) setState({ ...d, loaded: true }); });
    return () => { alive = false; };
  }, []);
  return state;
}

/**
 * `label(code)`: a plan's name as customers see it ("free" -> Free). Empty for the moment before the names load,
 * rather than flashing a built-in one.
 */
export function usePlanLabel() {
  const { names, loaded: ready } = usePlans();
  return (code) => (code === 'free' ? 'Free' : ready ? names[code] || code : '');
}
